import { GoogleGenerativeAI } from "@google/generative-ai";

const genAI = new GoogleGenerativeAI('AIzaSyAVy15vZjoG64KDQItY-tbiz15WbMYfgXA');

export async function runGenAi(message, history) {
    // For text-only input, use the gemini-pro model
    const model = genAI.getGenerativeModel({ model: "gemini-pro" });

    const chat = model.startChat({
        history: history,
        generationConfig: {
            maxOutputTokens: 10000,
        },
    });

    const msg = message;
    // const result = await chat.sendMessage(msg);
    const messHistory = await chat.getHistory();
    const result = await chat.sendMessage(msg);
    const response = await result.response;
    const text = response.text();
    return {
        text: text,
        history: messHistory,
    };
}




